import type { ColDef } from 'ag-grid-community';

import type { TypeExchangeItemAddData } from '~/types/claim.types';

/**
 * [교환 신청/조회] 교환 상품 추가 모달 > 테이블 컬럼 정의
 */
const getClaimExchangeItemsAddColumnDefs = () => {
  const columnDefs: ColDef<TypeExchangeItemAddData>[] = [
    {
      headerName: '',
      valueFormatter: () => '',
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 44,
    },
    {
      field: 'skuCode',
      headerName: '상품코드',
      width: 130,
    },
    {
      field: 'skuName',
      headerName: '상품명',
      minWidth: 565,
      flex: 1,
    },
  ];

  return { columnDefs };
};

export default getClaimExchangeItemsAddColumnDefs;
